import { Record as record } from 'immutable';

import { construct, fields } from '../../helpers/LinkMapper';

const defaults = {
    code: null,
    description: null,
    name: null,
    percentage: null,
    isPromotional: null,
};

class Discount extends record(defaults) {

    static fromJSON (json = {}) {
        return construct(Discount, json, {
            code: fields.string,
            description: fields.string,
            name: fields.string,
            percentage: fields.number,
            isPromotional: fields.boolean
        });
    }
}

export default Discount;
